<template>
  <div>
    <tasks-bar />
    <router-view></router-view>
  </div>
</template>

<script>
import TasksBar from "@/components/navigation-bar/TasksBar";
export default {
  components: {
    TasksBar,
  },
};
</script>
